import { init, configureScope } from '@sentry/browser';

export async function initSentry() {
  init({
    dsn: 'https://a15076dca0684c81903c7899fd2f7692@sentry.io/1196449',
    whitelistUrls: [
      'https://d2mr2bp22s0zi7.cloudfront.net',
      'https://campsite.bio',
      'https://app.campsite.bio',
    ],
    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      'Redirected when going from',
      'Permission denied to access property',
      "undefined is not an object (evaluating 'a.R')",
      // ResizeObserver noise
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      // Android WebView noise
      'Java object is gone',
      /Error invoking/,
      // iOS WebView / in-app browser noise
      /window\.webkit\.messageHandlers/,
      'The WKWebView was deallocated',
      // Media playback noise (user browser/device limitations)
      'NotSupportedError: The element has no supported sources',
      'NotSupportedError: Failed to load because no supported source was found',
      'NotAllowedError: play() can only be initiated by a user gesture',
      /The play\(\) request was interrupted/,
      'NotSupportedError: The operation is not supported.',
      // Browser extensions / crypto wallets
      'Invalid call to runtime.sendMessage()',
      'Failed to connect to MetaMask',
      /Cannot assign to read only property '(ethereum|tronLink)'/,
      /Cannot set property isMetaMask/,
      /Cannot redefine property: create/,
      'Extension context invalidated',
      /Invalid call to browser\.storage/,
      /cashbackReminder/,
      // Third-party SDK / injection
      /evaluating '(A|t)\.sdkVersion'/,
      /detectLanguage is not a function/,
      "Can't find variable: SCDynimacBridge",
      "Can't find variable: _G",
      "Can't find variable: CONFIG",
      // CSP violations from third-party scripts
      /Evaluating a string as JavaScript violates.*Content Security Policy/,
      // Browser feature detection
      "feature named `performanceMetrics` was not found",
      "feature named `pageObserver` was not found",
      // postMessage / origin noise (iframes, extensions)
      /Invalid target origin '\[object MessagePort\]'/,
      'invalid origin',
      /Failed to read a named property '.*' from 'Window'/,
      // reCAPTCHA timeouts (Google's infrastructure)
      'reCAPTCHA Timeout',
      // Old browser syntax errors (IE11, old Android WebView)
      "Unexpected token ';'",
      'Unexpected token .',
      'Unexpected end of input',
    ],
    denyUrls: [
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-extension:\/\//i,
    ],
  });
}

export async function configureUser(user) {
  if (!user || Object.keys(user).length === 0) return;

  configureScope((scope) => {
    scope.setUser({ id: user._id.$oid, email: user.email });
  });
}

export function configureProfile(profile) {
  configureScope((scope) => {
    if (!profile || !profile._id) {
      scope.setTag('profile', undefined);
      scope.setTag('profile_username', undefined);
      return;
    }
    scope.setTag('profile', profile._id.$oid);
    scope.setTag('profile_username', profile.username);
  });
}
